import { VALIDATED_BEFORE_MARKER } from './constants.mjs';

export default function isValidatedBefore(node) {
  return VALIDATED_BEFORE_MARKER in node.dataset;
}
